import React, { useState, useContext } from 'react';
import { Badge, TextStyle } from '@superops/ui-design-system';
import SchedulingContext from '../../Contexts/SchedulingContext';
import {
  GET_CALENDAR_SLA_DETAILS,
  GET_SLA_TICKETS
} from '@nile/graphql/src/Query/Scheduling/Calendar';
import { AccountClient, TicketClient, useQuery } from '@nile/graphql';
import { getCurrentUserHook } from '@nile/components/src';
import { getDayDetails } from '../../helpers';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';
import Tippy from '@tippyjs/react';
import SLATicketDetails from './SLATIcketDetails';
import dayjs from 'dayjs';

const SLAComponent = (props) => {
  const { startTime, endTime } = props;
  const currentUser = getCurrentUserHook();

  const [overDueCount, setOverDueCount] = useState('0');
  const [dueCount, setDueCount] = useState('0');
  const [overDueTickets, setOverDueTickets] = useState([]);
  const [dueTickets, setDueTickets] = useState([]);

  const popupParentName = 'slaDetailsPopUp';

  // const togglePopOver = () => {
  //   if (!tippyRef.current._tippy.state?.isVisible) {
  //     closeAllOpenPopups();
  //     setTippyVisible(true);
  //     tippyRef.current._tippy.show();
  //   } else if (tippyRef.current._tippy.state?.isVisible) {
  //     tippyRef.current._tippy.hide();
  //     setTippyVisible(false);
  //   }
  // };

  const { loading: listLoading, data: listData } = useQuery(GET_SLA_TICKETS, {
    client: TicketClient,
    fetchPolicy: 'network-only',
    variables: {
      listInfo: {
        page: 1,
        pageSize: 100,
        sort: [
          {
            attribute: 'resolutionDueTime',
            order: 'ASC'
          }
        ],
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              joinOperator: 'AND',
              operands: [
                {
                  attribute: 'ticketId',
                  operator: 'isNotEmpty',
                  value: ''
                }
              ]
            },
            {
              joinOperator: 'AND',
              operands: [
                {
                  joinOperator: 'AND',
                  operands: [
                    {
                      value: endTime,
                      operator: 'before',
                      operatorValue: null,
                      attribute: 'resolutionDueTime'
                    }
                  ]
                },
                {
                  joinOperator: 'AND',
                  operands: [
                    {
                      value: '',
                      operator: 'isEmpty',
                      operatorValue: null,
                      attribute: 'resolutionTime'
                    }
                  ]
                },
                {
                  joinOperator: 'AND',
                  operands: [
                    {
                      value: currentUser?.userId,
                      operator: 'is',
                      operatorValue: null,
                      attribute: 'technician.userId'
                    }
                  ]
                }
              ]
            }
          ]
        },
        view: {
          id: '1'
        }
      }
    },
    onCompleted(res) {
      const overDueTicketData = [];
      const dueTicketData = [];
      res?.getTicketList?.tickets.forEach((ticket) => {
        if (ticket?.resolutionViolated) {
          overDueTicketData.push(ticket);
        }

        if (!ticket?.resolutionViolated) {
          const isOverDueOnDay = dayjs(ticket?.resolutionDueTime).isBefore(
            dayjs(startTime)
          );
          if (isOverDueOnDay) {
            overDueTicketData.push(ticket);
          } else {
            dueTicketData.push(ticket);
          }
        }
      });
      if (!isEmpty(overDueTicketData)) {
        const overDueTicketCount = overDueTicketData?.length?.toString();
        setOverDueCount(overDueTicketCount);
        setOverDueTickets(overDueTicketData);
      }
      if (!isEmpty(dueTicketData)) {
        const dueTicketCount = dueTicketData?.length?.toString();
        setDueCount(dueTicketCount);
        setDueTickets(dueTicketData);
      }
    }
  });

  return (
    <>
      <Tippy
        content={
          <>
            <SLATicketDetails
              dueData={dueTickets}
              overDueData={overDueTickets}
              loading={listLoading}
            />
          </>
        }
        maxWidth={600}
        interactive
        placement="bottom-start"
        arrow={true}
        theme="light"
        allowHTML
        appendTo={document.body}
        trigger="click"
        zIndex={511}
      >
        <div
          className={`flex g10 actr mb-10 pointer pointer-events-all ${popupParentName}`}
        >
          <div className="flex g5 actr">
            <div>
              <TextStyle variation="subdued">{dueCount}</TextStyle>
            </div>
            <div className="fsize12 uppercase">
              <TextStyle variation="subdued">
                <FormattedMessage id="scheduling.header.sla.due" />
              </TextStyle>
            </div>
          </div>

          <div className="flex g5 actr">
            <div>
              <TextStyle variation="negative">{overDueCount}</TextStyle>
            </div>
            <div className="fsize12 uppercase">
              <TextStyle variation="negative">
                <FormattedMessage id="scheduling.header.sla.overdue" />
              </TextStyle>
            </div>
          </div>
        </div>
      </Tippy>
    </>
  );
};

const CalendarHeader = (props) => {
  const dayDetails = getDayDetails(props?.date);
  const schedulingContext = useContext(SchedulingContext);

  const isWeekView = schedulingContext?.calendarView === 'week';

  const showSla = schedulingContext?.showSla;

  const handleWeekHeaderClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      <div
        className={`SuperOps-Calendar-Day-header col astart jctr ${
          isWeekView ? 'actr' : ''
        }`}
        id="day-header"
        onClick={handleWeekHeaderClick}
      >
        <div>
          <div className="day-details">
            <div className="short-day">
              <TextStyle>{dayDetails?.shortDay}</TextStyle>
            </div>
            <div
              className={`date-number ${
                dayDetails?.isToday ? 'day-active' : ''
              }`}
            >
              <TextStyle>{dayDetails?.number}</TextStyle>
            </div>
          </div>
        </div>
        {showSla && (
          <div className="ml-10">
            <SLAComponent
              startTime={dayDetails?.startTime}
              endTime={dayDetails?.endTime}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default CalendarHeader;
